// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entries-notification-cut__title {
  text-align: left;
}
.entries-notification-cut__summary {
  min-height: 24px;
}
.entries-notification-cut__disclosure {
  width: 100%;
}
.entries-notification-cut__disclosure > * {
  width: 100%;
  justify-content: space-between;
}
.entries-notification-cut__cut:not(:last-child) .entries-notification-cut__disclosure {
  border-bottom: 1px solid var(--g-color-line-generic);
  padding-bottom: var(--g-spacing-4);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/CollectionsStructure/components/EntriesNotificationCut/EntriesNotificationCut.scss"],"names":[],"mappings":"AAKI;EACI,gBAAA;AAJR;AAOI;EACI,gBAPS;AAEjB;AAQI;EACI,WAAA;AANR;AAQQ;EACI,WAAA;EACA,8BAAA;AANZ;AAWQ;EACI,oDAAA;EACA,kCAAA;AATZ","sourcesContent":[".entries-notification-cut__title {\n  text-align: left;\n}\n.entries-notification-cut__summary {\n  min-height: 24px;\n}\n.entries-notification-cut__disclosure {\n  width: 100%;\n}\n.entries-notification-cut__disclosure > * {\n  width: 100%;\n  justify-content: space-between;\n}\n.entries-notification-cut__cut:not(:last-child) .entries-notification-cut__disclosure {\n  border-bottom: 1px solid var(--g-color-line-generic);\n  padding-bottom: var(--g-spacing-4);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
